import { Property, Type } from '@dipscope/type-manager';
import 'reflect-metadata';
import { Meeple } from '../tilebase/Meeple';

@Type({ injectable: true, discriminant: 'KMeeple' })
class KMeeple extends Meeple {}

export default KMeeple;
